import SoundManager from '../prefabs/SoundManager.js';
import AbstractScene from './AbstractScene.js';
import UI from './UI.js';

export default class Preloader extends AbstractScene {

    constructor() {
        super({
            key: "Preloader"
        })
    }
    init(data) {
        this._init(data);

        this.soundManager = new SoundManager()

    }

    preload() {
        this._preload();

        // Ajout du texte de chargement
        this.loadingText = this.make.text({
            x: this.width / 2,
            y: this.height / 2,
            text: 'Chargement... 0%',
            style: {
                font: '60px Inter',
                fill: '#000000',
                stroke: '#FFF',
                strokeThickness: 8
            }
        });

        this.loadingText.setOrigin(0.5, 0.5);

        this.loadSprites();

        this.load.on('progress', (value) => {
            // this.chargement.setScale(value, 1);
            this.loadingText.text = 'Chargement... ' + Math.floor(value * 100) + '%';
        });
        
        // this.load.on('fileprogress', function (file) {
            // console.log(file.src);
        // });

        this.load.on('complete', function () {
            this.scene.add('UI', UI, true);
            this.nextScene();
        }, this);
    }

    loadSprites() { 
        // Audios
        this.soundManager.loadAudios(this);

        // Config
        this.load.json('config', 'assets/config.json');
        this.load.html('videoPlayer', 'assets/iframe/video/domvideo.html');

        // Icons
        this.load.image('icon_perso', 'assets/images/icons/icon_perso.png');
        this.load.image('icon_etoiles', 'assets/images/icons/icon_etoiles.png');
        this.load.image('icon_fleche', 'assets/images/icons/icon_fleche.png');
        this.load.image('icon_close', 'assets/images/icons/icon_close.png');

        this.load.image('icon_google', 'assets/images/icons/icon_google.png');
        this.load.image('icon_hive', 'assets/images/icons/icon_hive.png');
        this.load.image('icon_wikipedia', 'assets/images/icons/icon_wikipedia.png');
        this.load.image('icon_instagram', 'assets/images/icons/icon_instagram.png');
        this.load.image('icon_linkedin', 'assets/images/icons/icon_linkedin.png');
        this.load.image('icon_scribbr', 'assets/images/icons/icon_scribbr.png');
        this.load.image('icon_encyclopaedia', 'assets/images/icons/icon_encyclopaedia.png');
        this.load.image('icon_chatgpt', 'assets/images/icons/icon_chatgpt.png');
        this.load.image('icon_facebook', 'assets/images/icons/icon_facebook.png');
        this.load.image('icon_google_map', 'assets/images/icons/icon_google_map.png');
        this.load.image('icon_metadata', 'assets/images/icons/icon_metadata.png');

        this.load.image('widget_google', 'assets/images/icons/widget_google.png');
        this.load.image('icon_facebook_smartphone', 'assets/images/icons/icon_facebook_smartphone.png');
        this.load.image('icon_wikiquote_smartphone', 'assets/images/icons/icon_wikiquote_smartphone.png');
        this.load.image('icon_google_smartphone', 'assets/images/icons/icon_google_smartphone.png');
        this.load.image('icon_instagram_smartphone', 'assets/images/icons/icon_instagram_smartphone.png');

        // Menu
        this.load.image('menu_background', 'assets/images/menu/menu_background.png');
        this.load.image('menu_titre', 'assets/images/menu/menu_titre.png');

        // Global 
        this.load.image('logo_CVC', 'assets/images/logo_CVC.png');
        this.load.image('rectangle_ombre_bleu', 'assets/images/rectangle_ombre_bleu.png');
        this.load.image('rectangle_ombre_rouge', 'assets/images/rectangle_ombre_rouge.png');

        // --- CHAPITRE 1 ---

        // Ordi
        this.load.image('Chapitre1_transition_background', 'assets/images/chapitre1/transition_background.png');
        this.load.image('Chapitre1_transition_titre', 'assets/images/chapitre1/transition_titre.png');
        this.load.image('Chapitre1_ordi_background', 'assets/images/chapitre1/ordi/ordi_background.png');
        this.load.image('Chapitre1_ordi_code', 'assets/images/chapitre1/ordi/ordi_code.png');

        this.load.image('Chapitre1_ordi_article_linkedin', 'assets/images/chapitre1/ordi/ordi_article_linkedin.png');
        this.load.image('Chapitre1_ordi_question_image_1', 'assets/images/chapitre1/ordi/ordi_question_image_1.png');
        this.load.image('Chapitre1_ordi_question_image_2', 'assets/images/chapitre1/ordi/ordi_question_image_2.png');
        this.load.image('Chapitre1_ordi_question_image_3', 'assets/images/chapitre1/ordi/ordi_question_image_3.png');

        this.load.image('Chapitre1_debrief_image', 'assets/images/chapitre1/debrief_image.png');


        // Point & Click
        this.load.image('Chapitre1_background', 'assets/images/chapitre1/background.png');
        this.load.image('Chapitre1_background_blurred', 'assets/images/chapitre1/background_blurred.png');

        this.load.image('decor_carte_postale_avant', 'assets/images/chapitre1/popups/carte_postale_avant.png');
        this.load.image('decor_carte_postale_arriere', 'assets/images/chapitre1/popups/carte_postale_arriere.png');
        this.load.image('decor_docteur', 'assets/images/chapitre1/popups/docteur.png');
        this.load.image('decor_billet_avion', 'assets/images/chapitre1/popups/billet_avion.png');
        this.load.image('decor_hibiscus', 'assets/images/chapitre1/popups/hibiscus.png');
        this.load.image('decor_toureiffel', 'assets/images/chapitre1/popups/toureiffel.png');
        this.load.image('decor_pissenlit', 'assets/images/chapitre1/popups/pissenlit.png');
        this.load.image('decor_edeilweiss', 'assets/images/chapitre1/popups/edeilweiss.png');
        this.load.image('decor_mug', 'assets/images/chapitre1/popups/mug.png');

        // --- CHAPITRE 2 ---

        // Transition
        this.load.image('Chapitre2_transition_background', 'assets/images/chapitre2/transition_background.png');
        this.load.image('Chapitre2_transition_titre', 'assets/images/chapitre2/transition_titre.png');

        // Ordi
        this.load.image('article_background', 'assets/images/chapitre2/ordi/article_background.png');
        this.load.image('faux_article', 'assets/images/chapitre2/ordi/faux_article.png');
        this.load.image('ordi_background', 'assets/images/chapitre2/ordi/ordi_background.png');
        this.load.image('ordi_code', 'assets/images/chapitre2/ordi/ordi_code.png');
        this.load.image('choix_text_background', 'assets/images/chapitre2/ordi/choix_text_background.png');
        this.load.image('button_shadow', 'assets/images/chapitre2/ordi/button_shadow.png');

        // Point & Click
        this.load.image('Chapitre2_background', 'assets/images/chapitre2/background.png');
        this.load.image('Chapitre2_background_blurred', 'assets/images/chapitre2/background_blurred.png');

        this.load.image('decor_calendrier', 'assets/images/chapitre2/popups/calendrier.png');
        this.load.image('decor_chaise_renversee', 'assets/images/chapitre2/popups/chaise_renversee.png');
        this.load.image('decor_chat', 'assets/images/chapitre2/popups/chat.png');
        this.load.image('decor_docteur_ara', 'assets/images/chapitre2/popups/docteur_ara.png');
        this.load.image('decor_dossier', 'assets/images/chapitre2/popups/dossier.png');
        this.load.image('decor_poster_christ_redempteur', 'assets/images/chapitre2/popups/poster_christ_redempteur.png');
        this.load.image('decor_verre', 'assets/images/chapitre2/popups/verre.png');
        this.load.image('decor_vue_fenetre', 'assets/images/chapitre2/popups/vue_fenetre.png');

        // --- CHAPITRE 3 ---

        // Transition
        this.load.image('Chapitre3_transition_background', 'assets/images/chapitre3/transition_background.png');
        this.load.image('Chapitre3_transition_titre', 'assets/images/chapitre3/transition_titre.png');

        // Point & Click
        this.load.image('Chapitre3_0_background', 'assets/images/chapitre3/background_exterieur.png');
        this.load.image('Chapitre3_0_background_blurred', 'assets/images/chapitre3/background_exterieur_blurred.png');
        this.load.image('Chapitre3_1_background', 'assets/images/chapitre3/background_interieur.png');
        this.load.image('Chapitre3_1_background_blurred', 'assets/images/chapitre3/background_interieur_blurred.png');

        this.load.image('decor_carton', 'assets/images/chapitre3/popups/carton.png');
        this.load.image('decor_employe_0', 'assets/images/chapitre3/popups/employe_0.png');
        this.load.image('decor_employe_1', 'assets/images/chapitre3/popups/employe_1.png');
        this.load.image('decor_slogan', 'assets/images/chapitre3/popups/slogan.png');
        this.load.image('decor_usine_exterieur', 'assets/images/chapitre3/popups/usine_exterieur.png');
        this.load.image('decor_vigile_0', 'assets/images/chapitre3/popups/vigile_0.png');
        this.load.image('decor_vigile_1', 'assets/images/chapitre3/popups/vigile_1.png');

        // SMartphone
        this.load.image('smartphone_background', 'assets/images/chapitre3/smartphone/smartphone_background.png');

        // --- CHAPITRE 4 ---
        // Transition
        this.load.image('Chapitre4_transition_background', 'assets/images/chapitre4/transition_background.png');
        this.load.image('Chapitre4_transition_titre', 'assets/images/chapitre4/transition_titre.png');

        // Ordi
        this.load.image('Chapitre4_ordi_background', 'assets/images/chapitre4/ordi/ordi_background.png');
        this.load.image('Chapitre4_ordi_code', 'assets/images/chapitre4/ordi/ordi_code.png');
        this.load.image('Chapitre4_ordi_question_image', 'assets/images/chapitre4/ordi/ordi_question_image.png');
        this.load.image('Chapitre4_ordi_article', 'assets/images/chapitre4/ordi/ordi_article.png');
        this.load.image('button_left', 'assets/images/chapitre4/ordi/button_left.png');

        this.load.image('decor_invitation', 'assets/images/chapitre4/ordi/decor_invitation.png');
        this.load.image('decor_presentoir', 'assets/images/chapitre4/ordi/decor_presentoir.png');
        this.load.image('decor_tokyo', 'assets/images/chapitre4/ordi/decor_tokyo.png');
        this.load.image('decor_portrait', 'assets/images/chapitre4/ordi/decor_portrait.png');
        this.load.image('decor_pub_tokyo', 'assets/images/chapitre4/ordi/decor_pub_tokyo.png');
        this.load.image('decor_discours', 'assets/images/chapitre4/ordi/decor_discours.png');
        this.load.image('decor_logo', 'assets/images/chapitre4/ordi/decor_logo.png');

        // Point & Click
        this.load.image('Chapitre4_background', 'assets/images/chapitre4/background.png');
        this.load.image('Chapitre4_background_blurred', 'assets/images/chapitre4/background_blurred.png');
        this.load.image('Chapitre4_background_cover', 'assets/images/chapitre4/background_cover.png');
        this.load.image('mask_lumiere', 'assets/images/chapitre4/mask_lumieres.png');

        // --- CHAPITRE 5 ---
        // Transition
        this.load.image('Chapitre5_transition_background', 'assets/images/chapitre5/transition_background.png');
        this.load.image('Chapitre5_transition_titre', 'assets/images/chapitre5/transition_titre.png');
        this.load.image('Chapitre5_transition_background_text', 'assets/images/chapitre5/background_text.png');
        this.load.image('Chapitre5_transition_perso', 'assets/images/chapitre5/perso.png');

        // Point & Click
        this.load.image('Chapitre5_0_background', 'assets/images/chapitre5/background.png');
        this.load.image('Chapitre5_0_background_blurred', 'assets/images/chapitre5/background_blurred.png');
        this.load.image('Chapitre5_1_background', 'assets/images/chapitre5/background_2.png');
        this.load.image('Chapitre5_1_background_blurred', 'assets/images/chapitre5/background_2_blurred.png');
        this.load.image('Chapitre5_2_background', 'assets/images/chapitre5/background_3.png');
        this.load.image('Chapitre5_2_background_blurred', 'assets/images/chapitre5/background_3_blurred.png');
        this.load.image('Chapitre5_3_background', 'assets/images/chapitre5/background_4.png');
        this.load.image('Chapitre5_3_background_blurred', 'assets/images/chapitre5/background_4_blurred.png');

        this.load.image('Chapitre5_2_video', 'assets/images/chapitre5/video.png');

        this.load.image('decor_balcon', 'assets/images/chapitre5/popups/decor_balcon.png');
        this.load.image('decor_bigboss', 'assets/images/chapitre5/popups/decor_bigboss.png');
        this.load.image('decor_chut', 'assets/images/chapitre5/popups/decor_chut.png');
        this.load.image('decor_chut_nuit', 'assets/images/chapitre5/popups/decor_chut_nuit.png');
        this.load.image('decor_discussion', 'assets/images/chapitre5/popups/decor_discussion.png');
        this.load.image('decor_garde', 'assets/images/chapitre5/popups/decor_garde.png');
        this.load.image('decor_garde_nuit', 'assets/images/chapitre5/popups/decor_garde_nuit.png');
        this.load.image('decor_porte', 'assets/images/chapitre5/popups/decor_porte.png');

        // --- CHAPITRE 6 ---
        this.load.image('Chapitre6_background', 'assets/images/chapitre6/background.png');

        this.load.image('decor_boom', 'assets/images/chapitre6/popups/decor_boom.png');
        this.load.image('decor_fin', 'assets/images/chapitre6/popups/decor_fin.png');
        this.load.image('decor_leila', 'assets/images/chapitre6/popups/decor_leila.png');
        this.load.image('decor_roue', 'assets/images/chapitre6/popups/decor_roue.png');

    }
}